export const einoptionConstants = {
  GET_OPTION_REQUEST: 'GET_OPTION_REQUEST',
  GET_OPTION_SUCCESS: 'GET_OPTION_SUCCESS',
};
